// extracted by mini-css-extract-plugin
module.exports = {"imagenBox1":"canales-info-module--imagenBox1--M4Mhh","marginLeftElement":"canales-info-module--marginLeftElement--prE9B"};